import { createFileRoute, useRouter } from '@tanstack/react-router';
import User from 'containers/User';

function ProfileRoute() {
  const router = useRouter();
  const handleNavigation = (path: string) => router.history.push(path);
  return <User handleNavigation={handleNavigation} />;
}

export const Route = createFileRoute('/_authenticated/profile')({
  component: ProfileRoute,
});
